@if (updateMode) {
<i-title [text]="titleUpdateMode" [buttons]="buttonsUpdateMode"></i-title>
}@else{
<i-title [text]="'advancedSearch.advancedSearch' | translate" [buttons]="buttons"></i-title>
}

<p-scrollPanel [style]="{ width: '100%', height: 'calc(100vh - 80px)' }" styleClass="custombar1">
  <div class="container mt-5">
    @if (updateMode) {
    <div class="row mb-4" [formGroup]="formSearchSaved">
      <div class="col-md-4">
        <label class="super-compos-label-input">{{ 'advancedSearch.description' | translate }}</label>
        <i-input [iInput]="{ placeholder: 'advancedSearch.description' | translate }" [type]="'text'"
          [control]="formSearchSaved.get('description')" [showError]="false" styleClass="d-block w-100"></i-input>
      </div>
      <div class="col-md-4">
        <label class="super-compos-label-input">{{ 'advancedSearch.displayOrder' | translate }}</label>
        <i-input [type]="'number'" [iInput]="{}" [control]="formSearchSaved.get('displayOrder')"
          styleClass="d-block w-100"> </i-input>
      </div>
      <div class="col-md-4">
        <label class="super-compos-label-input">{{ 'advancedSearch.hiddenInDashboard' | translate }}</label>
        <p-checkbox name="hideInDashboard" formControlName="hideInDashboard" binary="true"></p-checkbox>
      </div>
    </div>
    }
    <form class="" [formGroup]="formSearch" autocomplete="false | unknown-autocomplete-value">
      <i-accordion [title]="'advancedSearch.searchCriteria' | translate" (showAllChange)="showAllChange($event)">
        <i-accordion-tab [header]="'advancedSearch.generalData' | translate" [showEditBtn]="false"
          [(selected)]="accordionGeneralSelected"
          (selectEmitter)="changeAccordionSelectionState($event, 'accordionGeneralSelected')">
          <ng-template pTemplate="header">
            @if (generalDatasFilterActive.length === 1) {
            <span class="activeFilter">1 {{ 'advancedSearch.singleFilterActive' | translate }}</span>
            } @else if (generalDatasFilterActive.length > 1) {
            <span class="activeFilter">{{ generalDatasFilterActive.length }} {{ 'advancedSearch.multipleFiltersActive' |
              translate }}</span>
            }
          </ng-template>
          <div class="row">
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.confidential' | translate }}</label>
              <p-inputSwitch formControlName="Confidentiel"
                (onChange)="changeGeneralDataFilter('Confidentiel')"></p-inputSwitch>
            </div>
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.searchInObject' | translate }}</label>
              <p-inputSwitch formControlName="BoolObjetText"
                (onChange)="changeGeneralDataFilter('BoolObjetText')"></p-inputSwitch>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.category' | translate }}</label>
              <p-dropdown [placeholder]="'advancedSearch.chooseCategory' | translate" [options]="boxesOptions"
                appendTo="body" formControlName="Tag" [showClear]="true" (onChange)="changeGeneralDataFilter('Tag')">
                <ng-template let-tag pTemplate="selectedItem">
                  <div><i class="{{ tag?.icon }} me-3"></i>{{ tag.label | translate }}</div>
                </ng-template>
                <ng-template let-tag pTemplate="item">
                  <div class="ui-helper-clearfix">
                    <div><i class="{{ tag?.icon }} me-3"></i>{{ tag.label | translate }}</div>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.object' | translate }}</label>
              <i-input [iInput]="{ placeholder: '' }" [type]="'text'" [control]="formSearch.get('Objet')"
                [showError]="false" styleClass="d-block w-100" (keyup)="changeGeneralDataFilter('Objet')"></i-input>
            </div>
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.service' | translate }}</label>
              <p-treeSelect #treeSelect [propagateSelectionUp]="false" [propagateSelectionDown]="true"
                selectionMode="checkbox" [options]="servicesList" [placeholder]="'pleaseSelectAService' | translate"
                appendTo="body" (onNodeSelect)="select()" (onNodeUnselect)="unselect($event)"
                [emptyMessage]="'noResultFound' | translate" [filter]="true"
                [filterPlaceholder]="'global.filterPlaceholder' | translate" [filterBy]="'label'"
                [filterMode]="'strict'" [metaKeySelection]="false"></p-treeSelect>
            </div>
          </div>
          <div class="row">
            @if (displayCourrierType) {
            <div class="col-md-4 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.mailType' | translate }}</label>
              <p-dropdown [placeholder]="'advancedSearch.chooseType' | translate" [options]="typeEntrantSortantLV"
                appendTo="body" formControlName="Type" [showClear]="true" (onChange)="changeGeneralDataFilter('Type')">
                <ng-template let-type pTemplate="selectedItem">
                  <div>{{ type.label | translate }}</div>
                </ng-template>
                <ng-template let-type pTemplate="item">
                  <div class="ui-helper-clearfix">
                    <div>{{ type.label | translate }}</div>
                  </div>
                </ng-template></p-dropdown>
            </div>
            }
            <div class="col-md-4 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.archiveBox' | translate }}</label>
              <i-input [iInput]="{ placeholder: 'advancedSearch.object' | translate }" [type]="'text'"
                [control]="formSearch.get('BoiteArchive')" [showError]="false" styleClass="d-block w-100"
                (keyup)="changeGeneralDataFilter('BoiteArchive')"></i-input>
            </div>
            <div class="col-md-4 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.mailID' | translate }}</label>
              <i-input [iInput]="{ placeholder: 'advancedSearch.object' | translate }" [type]="'text'"
                [control]="formSearch.get('Id')" [showError]="false" styleClass="d-block w-100"
                (keyup)="changeGeneralDataFilter('Id')"></i-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="row align-items-center">
                <div class="col-md-5 mb-3 p-fluid">
                  <label class="super-compos-label-input d-flex align-items-center gap-2">
                    {{ 'advancedSearch.entryDateFrom' | translate }}
                    <i class="bi bi-info-circle cursor--pointer"
                      [pTooltip]="('advancedSearch.entryDateDefaultTooltip' | translate: { defaultDateRange: defaultSearchDateRange })"
                      tooltipPosition="top">
                    </i>
                  </label>
                  <p-calendar [firstDayOfWeek]="1" appendTo="body" formControlName="DtEntreeMin" [showIcon]="true"
                    [iconDisplay]="'input'" dateFormat="dd/mm/yy" (onSelect)="changeGeneralDataFilter('DtEntreeMin')"
                    (onInput)="changeGeneralDataFilter('DtEntreeMin')">
                  </p-calendar>
                </div>
                <div class="col-md-2 mb-3 p-fluid text-center">
                  <i class="bi bi-arrow-right" style="font-size: 30px"></i>
                </div>
                <div class="col-md-5 mb-3 p-fluid">
                  <label class="super-compos-label-input">
                    {{ 'advancedSearch.entryDateTo' | translate }}
                  </label>
                  <p-calendar [firstDayOfWeek]="1" appendTo="body" formControlName="DtEntreeMax" [showIcon]="true"
                    [iconDisplay]="'input'" dateFormat="dd/mm/yy" (onSelect)="changeGeneralDataFilter('DtEntreeMax')"
                    (onInput)="changeGeneralDataFilter('DtEntreeMax')">
                  </p-calendar>
                </div>
              </div>
            </div>
          </div>
        </i-accordion-tab>

        <i-accordion-tab [header]="'Données Expéditeur'" [showEditBtn]="false"
          [(selected)]="accordionExpediteursSelected"
          (selectEmitter)="changeAccordionSelectionState($event, 'accordionExpediteursSelected')">
          <ng-template pTemplate="header">
            @if (expediteursDatasFilterActive.length === 1) {
            <span class="activeFilter">1 {{ 'advancedSearch.singleFilterActive' | translate }}</span>
            } @else if (expediteursDatasFilterActive.length > 1) {
            <span class="activeFilter">{{ expediteursDatasFilterActive.length }} {{
              'advancedSearch.multipleFiltersActive' | translate }}</span>
            }
          </ng-template>
          <div class="row">
            <div class="col-12 mb-3 align-items-center">
              <label class="super-compos-label-input">{{ 'advancedSearch.sender' | translate }}</label>
              <div class="d-flex align-items-center">
                <p-toggleButton styleClass="custom-toggle-button_advancedSearch"
                  [onLabel]="'mainNav.contacts' | translate" [offLabel]="'mainNav.users' | translate"
                  [onIcon]="'bi bi-person-vcard'" [offIcon]="'bi bi-person'" [(ngModel)]="senderSourceBoolean"
                  [ngModelOptions]="{ standalone: true }"
                  (onChange)="onChangeToggleButtonUsersContacts('sendersSource', $event)"></p-toggleButton>
                <p-multiSelect class="w-100" styleClass="custom-multi-select_advancedSearch"
                  [placeholder]="'advancedSearch.chooseSender' | translate" [formControl]="formControlNameForSender"
                  appendTo="body" [virtualScroll]="true" [filter]="true" virtualScrollItemSize="30"
                  [options]="sendersContacts | sort: 'label' : 'ASC'" selectedItemsLabel="{0} éléments sélectionnés"
                  emptyFilterMessage="Pas de résultats" [resetFilterOnHide]="true"
                  (onChange)="changeExpediteursDataFilter(formSearch.value.sendersSource === 'iAdmin' ? 'ExpediteurIdiAdmins' : 'ExpediteurIds')">
                  <ng-template let-user pTemplate="item">
                    <div class="d-flex align-items-center justify-content-between w-100">
                      {{ user.label }}
                      @if (formSearch.value.sendersSource === 'iCourrier') {
                      <div style="font-size: 14px"
                        (click)="showUserTooltip(user); displayComplementaryInfosForAContact = true">
                        <i class="bi bi-eye-fill"></i>
                      </div>
                      }
                    </div>
                  </ng-template>
                </p-multiSelect>
              </div>
            </div>
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.freeSender' | translate }}</label>
              <i-input [iInput]="{ placeholder: '' }" [type]="'text'" [control]="formSearch.get('ExpediteurLibre')"
                [showError]="false" styleClass="d-block w-100"
                (keyup)="changeExpediteursDataFilter('ExpediteurLibre')"></i-input>
            </div>
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.senderRef' | translate }}</label>
              <i-input [iInput]="{ placeholder: '' }" [type]="'text'" [control]="formSearch.get('RefExpediteur')"
                [showError]="false" styleClass="d-block w-100"
                (keyup)="changeExpediteursDataFilter('RefExpediteur')"></i-input>
            </div>
          </div>
        </i-accordion-tab>

        <i-accordion-tab [header]="'Données Destinataire'" [showEditBtn]="false"
          [(selected)]="accordionRecipientSelected"
          (selectEmitter)="changeAccordionSelectionState($event, 'accordionRecipientSelected')">
          <ng-template pTemplate="header">
            @if (destinatairesDatasFilterActive.length === 1) {
            <span class="activeFilter">1 {{ 'advancedSearch.singleFilterActive' | translate }}</span>
            } @else if (destinatairesDatasFilterActive.length > 1) {
            <span class="activeFilter">{{ destinatairesDatasFilterActive.length }} {{
              'advancedSearch.multipleFiltersActive' | translate }}</span>
            }
          </ng-template>
          <div class="row">
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.mailsWithoutRecipientServices' | translate
                }}</label>
              <p-inputSwitch formControlName="CourrierSansServices"
                (onChange)="changeDestinataireDataFilter('CourrierSansServices')"></p-inputSwitch>
            </div>
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.mailsWithoutRecipient' | translate }}</label>
              <p-inputSwitch formControlName="CourrierSansDestinataires"
                (onChange)="changeDestinataireDataFilter('CourrierSansDestinataires')"></p-inputSwitch>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-3 align-items-center">
              <label class="super-compos-label-input">{{ 'advancedSearch.recipientType' | translate }}</label>
              <div class="d-flex align-items-center">
                <p-toggleButton styleClass="custom-toggle-button_advancedSearch"
                  [onLabel]="'mainNav.contacts' | translate" [offLabel]="'mainNav.users' | translate"
                  [onIcon]="'bi bi-person-vcard'" [offIcon]="'bi bi-person'" [(ngModel)]="recipientSourceBoolean"
                  [ngModelOptions]="{ standalone: true }"
                  (onChange)="onChangeToggleButtonUsersContacts('recipientsSource', $event)"></p-toggleButton>
                <p-multiSelect class="w-100" styleClass="custom-multi-select_advancedSearch"
                  [placeholder]="'advancedSearch.chooseRecipient' | translate"
                  [formControl]="formControlNameForRecipient" appendTo="body" [virtualScroll]="true" [filter]="true"
                  virtualScrollItemSize="30" [options]="recipientsContacts | sort: 'label' : 'ASC'"
                  selectedItemsLabel="{0} éléments sélectionnés" emptyFilterMessage="Pas de résultats"
                  [resetFilterOnHide]="true" (onChange)="
                    changeDestinataireDataFilter(formSearch.value.recipientsSource === 'iAdmin' ? 'DestinataireIdiAdmins' : 'DestinataireIds')
                  "></p-multiSelect>
              </div>
            </div>
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.freeAddress' | translate }}</label>
              <i-input [iInput]="{ placeholder: '' }" [type]="'text'" [control]="formSearch.get('DestinataireLibre')"
                [showError]="false" styleClass="d-block w-100"
                (keyup)="changeDestinataireDataFilter('DestinataireLibre')"></i-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.recipientService' | translate }}</label>
              <p-treeSelect class="treeSelectDestServices" [emptyMessage]="'noResultFound' | translate"
                [options]="serviceParent" #treeSelectDestServices selectionMode="single"
                [placeholder]="'pleaseSelectAService' | translate" appendTo="body"
                (onNodeSelect)="selectDestServices($event)" [filter]="true"
                [filterPlaceholder]="'global.filterPlaceholder' | translate" [filterBy]="'label'"
                [filterMode]="'strict'" [metaKeySelection]="false"></p-treeSelect>
            </div>
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.recommendedRef' | translate }}</label>
              <i-input [iInput]="{ placeholder: '' }" [type]="'text'" [control]="formSearch.get('ReferenceRecommande')"
                [showError]="false" styleClass="d-block w-100"
                (keyup)="changeDestinataireDataFilter('ReferenceRecommande')"></i-input>
            </div>
          </div>
        </i-accordion-tab>

        <i-accordion-tab [header]="'advancedSearch.additionalData' | translate" [showEditBtn]="false"
          [(selected)]="accordionSupplementarySelected"
          (selectEmitter)="changeAccordionSelectionState($event, 'accordionSupplementarySelected')">
          <ng-template pTemplate="header">
            @if (donneesSupplementairesDatasFilterActive.length === 1) {
            <span class="activeFilter">1 {{ 'advancedSearch.singleFilterActive' | translate }}</span>
            } @else if (donneesSupplementairesDatasFilterActive.length > 1) {
            <span class="activeFilter">{{ donneesSupplementairesDatasFilterActive.length }} {{
              'advancedSearch.multipleFiltersActive' | translate }}</span>
            }
          </ng-template>
          <div class="row">
            @if (configuration?.mails.hideClassementDossiers === false) {
            <div class="col-md-12 mb-3 p-fluid">
              <label class="super-compos-label-input d-flex align-items-center justify-content-between">
                <div>
                  {{ 'advancedSearch.classification' | translate }}
                  <i class="bi bi-question-circle cursor--pointer"
                    [pTooltip]="'advancedSearch.classificationCodeTooltip' | translate"></i>
                </div>
                <div>
                  <i class="bi bi-search cursor--pointer"
                    [ngClass]="{ 'bi-search__grayIcon': formSearch.value.SvcPropIds?.length !== 1 }"
                    [pTooltip]="getTooltipForClassificationSearch()" (click)="openModalClassement()"></i>
                </div>
              </label>
              @if (classificationCodesLV.length > 0) {
              <p-multiSelect formControlName="ClassementIds"
                [placeholder]="'advancedSearch.chooseClassification' | translate"
                [options]="classificationCodesLV | sort: 'label' : 'ASC'" appendTo="body" [virtualScroll]="true"
                virtualScrollItemSize="30"
                (onChange)="changeDonneesSupplementairesDataFilter('ClassementIds')"></p-multiSelect>
              }
              @if (classificationCodesLV.length === 0) {
              <div class="alert alert-info">{{ 'advancedSearch.noClassificationCode' | translate }}</div>
              }
            </div>
            }
          </div>
          <div class="row">
            @if (formSearch.value.ClassementIds?.length === 1 && formSearch.value.SvcPropIds?.length === 1) {
            <div class="col-md-12 mb-3 p-fluid">
              <div class="d-flex">
                <label class="super-compos-label-input">{{ 'folder' | translate }}</label>
                <p-checkbox class="ms-1" binary="true" formControlName="checkBindersIsArchived"
                  (onChange)="displayArchived('binder')"></p-checkbox>
                <span class="displayArchivedClassementLabel">{{ 'displayArchived' | translate }}</span>
              </div>
              @if (binders.length > 0) {
              <p-dropdown styleClass="w-100 dropdown-inforius" formControlName="ClasseurId" appendTo="body"
                autocomplete="new-password" id="classeurId" [showClear]="true"
                [options]="binders | sort: 'description' : 'ASC'" [placeholder]="'pleaseSelectAFolder' | translate"
                [filter]="true" [emptyFilterMessage]="'noResultFound' | translate" [virtualScroll]="true"
                [virtualScrollItemSize]="31" [attr.data-test]="'classeur'" [optionLabel]="'description'"
                [optionValue]="'id'" (onChange)="changeDonneesSupplementairesDataFilter('ClasseurId')">
                <ng-template let-item pTemplate="selectedItem">
                  @if (item?.partage) {
                  <i class="bi bi-people-fill"></i>
                  }
                  {{ item?.description }}
                </ng-template>
                <ng-template let-item pTemplate="item">
                  <div class="d-flex align-items-center justify-content-between overflow-ellipsis">
                    <div [pTooltip]="item.description">
                      @if (item?.partage) {
                      <i class="bi bi-people-fill me-1"></i>
                      }
                      {{ item?.description }}
                    </div>
                  </div>
                </ng-template>
              </p-dropdown>
              }
              @if (binders.length === 0) {
              <div class="form-group col-4 input-warning">{{ 'noFolderAvailable' | translate }}</div>
              }
            </div>
            }
          </div>
          <div class="row">
            @if (formSearch.value.ClasseurId) {
            <div class="col-md-12 mb-3 p-fluid">
              <div class="d-flex">
                <label class="super-compos-label-input">{{ 'plasticLiner' | translate }}</label>
                <p-checkbox class="ms-1" binary="true" formControlName="checkFoldersIsArchived"
                  (onChange)="displayArchived('folder')"></p-checkbox>
                <span class="displayArchivedClassementLabel">{{ 'displayArchived' | translate }}</span>
              </div>
              @if (folders.length > 0) {
              <p-dropdown styleClass="w-100 dropdown-inforius" formControlName="ChemiseId" appendTo="body"
                autocomplete="new-password" id="chemiseId" [showClear]="true"
                [options]="folders | sort: 'description' : 'ASC'"
                [placeholder]="'pleaseSelectAPlasticLiner' | translate" [filter]="true" [virtualScroll]="true"
                [virtualScrollItemSize]="31" [emptyFilterMessage]="'noResultFound' | translate"
                [optionLabel]="'description'" [optionValue]="'id'" [attr.data-test]="'chemise'"
                (onChange)="changeDonneesSupplementairesDataFilter('ChemiseId')">
                <ng-template let-item pTemplate="selectedItem">
                  @if (item?.partage) {
                  <i class="bi bi-people-fill"></i>
                  }
                  {{ item?.description }}
                </ng-template>
                <ng-template let-item pTemplate="item">
                  <div class="d-flex align-items-center justify-content-between overflow-ellipsis">
                    <div [pTooltip]="item.description">
                      @if (item?.partage) {
                      <i class="bi bi-people-fill me-1"></i>
                      }
                      {{ item?.description }}
                    </div>
                  </div>
                </ng-template>
              </p-dropdown>
              }
              @if (folders.length === 0) {
              <div class="form-group col-4 input-warning">{{ 'noPLasticLinerAvailable' | translate }}</div>
              }
            </div>
            }
          </div>
          <div class="row">
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.nature' | translate }}</label>
              <p-multiSelect [placeholder]="'advancedSearch.chooseNature' | translate" formControlName="NatureIds"
                [options]="natureListLV | sort: 'labelToSort'" appendTo="body" [virtualScroll]="true"
                virtualScrollItemSize="30"
                (onChange)="changeDonneesSupplementairesDataFilter('NatureIds')"></p-multiSelect>
            </div>
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.label' | translate }}</label>
              <p-multiSelect [placeholder]="'advancedSearch.chooseLabel' | translate" formControlName="MultipleStIds"
                [virtualScroll]="true" virtualScrollItemSize="30" [options]="tags" appendTo="body"
                (onChange)="changeDonneesSupplementairesDataFilter('MultipleStIds')"></p-multiSelect>
            </div>

            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.source' | translate }}</label>
              <p-multiSelect [placeholder]="'advancedSearch.chooseSource' | translate" formControlName="SourceIds"
                [options]="sourceListLV" appendTo="body" [virtualScroll]="true" virtualScrollItemSize="30"
                (onChange)="changeDonneesSupplementairesDataFilter('SourceIds')"></p-multiSelect>
            </div>
            <div class="col-md-6 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.status' | translate }}</label>
              <p-dropdown [placeholder]="'advancedSearch.chooseStatus' | translate" [options]="statutGlobalLV"
                appendTo="body" formControlName="StIds" [virtualScroll]="true" virtualScrollItemSize="30"
                [filter]="true" [showClear]="true" (onChange)="changeDonneesSupplementairesDataFilter('StIds')">
                <ng-template let-item pTemplate="selectedItem">
                  <span [ngStyle]="{ color: item?.textColor, 'background-color': item?.color }">{{ item?.label }}</span>
                </ng-template>
                <ng-template let-statut pTemplate="item">
                  <div class="p-2" [style.background-color]="statut.color" [style.color]="statut.textColor">{{
                    statut.label }}</div>
                </ng-template>
              </p-dropdown>
            </div>
          </div>
        </i-accordion-tab>

        @if (formSearch.value.NatureIds?.length === 1 && hasNatureComplementaryDatas) {
        <i-accordion-tab [header]="'advancedSearch.additionalDataRelatedToNature' | translate" [showEditBtn]="false"
          [(selected)]="accordionComplementarySelected"
          (selectEmitter)="changeAccordionSelectionState($event, 'accordionComplementarySelected')">
          <ng-template pTemplate="header">
            @if (countOfComplementaryDatasNature === 1) {
            <span class="activeFilter">1 {{ 'advancedSearch.singleFilterActive' | translate }}</span>
            } @else if (countOfComplementaryDatasNature > 1) {
            <span class="activeFilter">{{ countOfComplementaryDatasNature }} {{ 'advancedSearch.multipleFiltersActive' |
              translate }}</span>
            }
          </ng-template>
          <div class="row">
            @if (dataToPrepareForForm?.controls?.length > 0) {
            <div class="complementdata col-md-12">
              <app-complement-data-form [natureWithComplementaryDatas]="natureWithComplementaryDatas"
                [isAdvancedSearch]="true" [formData]="dataToPrepareForForm"
                (formValue)="receive_complementData($event)"></app-complement-data-form>
            </div>
            }
          </div>
        </i-accordion-tab>
        }

        <i-accordion-tab [header]="'advancedSearch.dates' | translate" [showEditBtn]="false"
          [(selected)]="accordionDatesSelected"
          (selectEmitter)="changeAccordionSelectionState($event, 'accordionDatesSelected')">
          <ng-template pTemplate="header">
            @if (datesDatasFilterActive.length === 1) {
            <span class="activeFilter">1 {{ 'advancedSearch.singleFilterActive' | translate }}</span>
            } @else if (datesDatasFilterActive.length > 1) {
            <span class="activeFilter">{{ datesDatasFilterActive.length }} {{ 'advancedSearch.multipleFiltersActive' |
              translate }}</span>
            }
          </ng-template>

          <div class="row">
            <div class="col-md-12 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.dateRecurrence' | translate }}</label>
              <p-inputSwitch formControlName="recurrence"
                (onChange)="changeDataDataFilter('recurrence')"></p-inputSwitch>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="row align-items-center" style="border-right: 1px solid #ccc">
                <div class="col-md-5 mb-3 p-fluid">
                  <label class="super-compos-label-input">{{ 'advancedSearch.dueDateFrom' | translate }}</label>
                  <p-calendar [firstDayOfWeek]="1" appendTo="body" formControlName="DtEcheanceMin" [showIcon]="true"
                    [iconDisplay]="'input'" dateFormat="dd/mm/yy" (onSelect)="changeDataDataFilter('DtEcheanceMin')"
                    (onInput)="changeDataDataFilter('DtEcheanceMin')">
                  </p-calendar>
                </div>
                <div class="col-md-2 mb-3 p-fluid text-center">
                  <i class="bi bi-arrow-right" style="font-size: 30px"></i>
                </div>
                <div class="col-md-5 mb-3 p-fluid">
                  <label class="super-compos-label-input">{{ 'advancedSearch.dueDateTo' | translate }}</label>
                  <p-calendar [firstDayOfWeek]="1" appendTo="body" formControlName="DtEcheanceMax" [showIcon]="true"
                    [iconDisplay]="'input'" dateFormat="dd/mm/yy" (onSelect)="changeDataDataFilter('DtEcheanceMax')"
                    (onInput)="changeDataDataFilter('DtEcheanceMax')">
                  </p-calendar>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row align-items-center">
                <div class="col-md-5 mb-3 p-fluid">
                  <label class="super-compos-label-input">{{ 'advancedSearch.docDateFrom' | translate }}</label>
                  <p-calendar [firstDayOfWeek]="1" appendTo="body" formControlName="DtDocumentMin" [showIcon]="true"
                    [iconDisplay]="'input'" dateFormat="dd/mm/yy" (onSelect)="changeDataDataFilter('DtDocumentMin')"
                    (onInput)="changeDataDataFilter('DtDocumentMin')">
                  </p-calendar>
                </div>
                <div class="col-md-2 mb-3 p-fluid text-center">
                  <i class="bi bi-arrow-right" style="font-size: 30px"></i>
                </div>
                <div class="col-md-5 mb-3 p-fluid">
                  <label class="super-compos-label-input">{{ 'advancedSearch.docDateTo' | translate }}</label>
                  <p-calendar [firstDayOfWeek]="1" appendTo="body" formControlName="DtDocumentMax" [showIcon]="true"
                    [iconDisplay]="'input'" dateFormat="dd/mm/yy" (onSelect)="changeDataDataFilter('DtDocumentMax')"
                    (onInput)="changeDataDataFilter('DtDocumentMax')">
                  </p-calendar>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="row align-items-center" style="border-right: 1px solid #ccc">
                <div class="col-md-5 mb-3 p-fluid">
                  <label class="super-compos-label-input">{{ 'advancedSearch.postalDateFrom' | translate }}</label>
                  <p-calendar [firstDayOfWeek]="1" appendTo="body" formControlName="DtPostaleMin" [showIcon]="true"
                    [iconDisplay]="'input'" dateFormat="dd/mm/yy" (onSelect)="changeDataDataFilter('DtPostaleMin')"
                    (onInput)="changeDataDataFilter('DtPostaleMin')">
                  </p-calendar>
                </div>
                <div class="col-md-2 mb-3 p-fluid text-center">
                  <i class="bi bi-arrow-right" style="font-size: 30px"></i>
                </div>
                <div class="col-md-5 mb-3 p-fluid">
                  <label class="super-compos-label-input">{{ 'advancedSearch.postalDateTo' | translate }}</label>
                  <p-calendar [firstDayOfWeek]="1" appendTo="body" formControlName="DtPostaleMax" [showIcon]="true"
                    [iconDisplay]="'input'" dateFormat="dd/mm/yy" (onSelect)="changeDataDataFilter('DtPostaleMax')"
                    (onInput)="changeDataDataFilter('DtPostaleMax')">
                  </p-calendar>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row align-items-center">
                <div class="col-md-5 mb-3 p-fluid">
                  <label class="super-compos-label-input">{{ 'advancedSearch.EncodeDateFrom' | translate }}</label>
                  <p-calendar [firstDayOfWeek]="1" appendTo="body" formControlName="DtEncodageMin" [showIcon]="true"
                    [iconDisplay]="'input'" dateFormat="dd/mm/yy" (onSelect)="changeDataDataFilter('DtEncodageMin')"
                    (onInput)="changeDataDataFilter('DtEncodageMin')">
                  </p-calendar>
                </div>
                <div class="col-md-2 mb-3 p-fluid text-center">
                  <i class="bi bi-arrow-right" style="font-size: 30px"></i>
                </div>
                <div class="col-md-5 mb-3 p-fluid">
                  <label class="super-compos-label-input">{{ 'advancedSearch.EncodeDateTo' | translate }}</label>
                  <p-calendar [firstDayOfWeek]="1" appendTo="body" formControlName="DtEncodageMax" [showIcon]="true"
                    [iconDisplay]="'input'" dateFormat="dd/mm/yy" (onSelect)="changeDataDataFilter('DtEncodageMax')"
                    (onInput)="changeDataDataFilter('DtEncodageMax')">
                  </p-calendar>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 mb-3 p-fluid">
              <label class="super-compos-label-input">{{ 'advancedSearch.note' | translate }}</label>
              <i-input [iInput]="{ placeholder: '' }" [type]="'text'" [control]="formSearch.get('Remarques')"
                [showError]="false" styleClass="d-block w-100" (keyup)="changeDataDataFilter('Remarques')"></i-input>
            </div>
          </div>
        </i-accordion-tab>
      </i-accordion>
    </form>
  </div>
</p-scrollPanel>
<p-dialog header="Informations complémentaires" [(visible)]="displayComplementaryInfosForAContact">
  <div class="row mt-3">
    <div class="col-md-12">
      @if (contactInfosComplementary.length > 0) {
      <i-table [paginator]="true" class="super-table" [columns]="columnsContactInfoComplementary"
        [items]="contactInfosComplementary" id="contactInfosComplementary" [multiselect]="false">
      </i-table>
      }
    </div>
  </div>
</p-dialog>

<!-- Affichage des recherches sauvegardées -->
<p-dialog header="Liste des recherches sauvegardées" [(visible)]="openSavedSearchs" [modal]="true" appendTo="body"
  [style]="{ width: '50vw' }">
  <i-table [paginator]="true" class="super-table" [columns]="savedSearchColumn"
    [items]="itemsSaved | sort: 'description' : 'ASC'" id="super-table-items-saved-advanced-search"
    [multiselect]="false"></i-table>
</p-dialog>
<p-dialog [(visible)]="savedModal" [modal]="true" [closable]="false" appendTo="body" [style]="{ width: '50vw' }">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'advancedSearch.saveSearch' | translate }}</h5>
      <div class="d-flex align-items-center">
        <i-button styleClass="blue" (click)="savedModal = false" [text]="'cancel' | translate"></i-button>
        <i-button styleClass="green ms-3" (click)="saveSearch()" [text]="'confirm' | translate"></i-button>
      </div>
    </div>
  </p-header>
  <div class="row" [formGroup]="formSearchSaved">
    <div class="col-md-4">
      <label class="super-compos-label-input">{{ 'advancedSearch.description' | translate }} *</label>
      <i-input [iInput]="{ placeholder: '' }" [type]="'text'" [control]="formSearchSaved.get('description')"
        [showError]="false" styleClass="d-block w-100" (keyup)="changeDataDataFilter('Remarques')"></i-input>
    </div>
    <div class="col-md-4">
      <label class="super-compos-label-input">{{ 'advancedSearch.displayOrder' | translate }}</label>
      <i-input [type]="'number'" [iInput]="{ placeholder: '' }" [control]="formSearchSaved.get('displayOrder')"
        styleClass="d-block w-100"> </i-input>
    </div>
    <div class="col-md-4">
      <label class="super-compos-label-input">{{ 'advancedSearch.hiddenInDashboard' | translate }}</label>
      <p-checkbox name="hideInDashboard" formControlName="hideInDashboard" binary="true"></p-checkbox>
    </div>
  </div>
</p-dialog>

@if (displayModalClassificationSearch) {
<p-dialog appendTo="body" [modal]="false" [closable]="true" [showHeader]="true" [header]="headerForModal"
  [style]="{ width: '60vw' }" [(visible)]="displayModalClassificationSearch">
  <app-classement-modal [courrier]="serviceDataForClassificationSearchModal" [advancedMode]="true"
    (closeClassificationSearchModal)="onCloseClassificationSearchModal($event)">
  </app-classement-modal>
</p-dialog>
}

<p-confirmDialog key="confirmReinitSavedSearch" #cd appendTo="body" styleClass="super-compos-modal-content confirmModal"
  header="Confirmation" icon="bi bi-exclamation-triangle" baseZIndex="1000">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate"
      (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>